<template>
  <div class="join-page-step">
    <div class="container container--mw-xxxl join-page-step__container">
      <div class="row justify-content-center">
        <div class="col join-page-step__column">
          <FormulateForm @submit="createAccount()">
            <h1 class="formulate-form__heading">Create your account</h1>

            <p class="formulate-form__step-copy">step 1 of 3</p>

            <FormulateInput
              type="text"
              v-model="user_name"
              label="Name"
              validation="required"
              :wrapper-class="['formulate-input-wrapper--container']"
              :label-class="['formulate-input-label--contained']"
              :element-class="['formulate-input-element--contained']"
            />

            <FormulateInput
              v-model="user_email"
              type="email"
              name="email"
              label="Email"
              validation="required|email"
              :wrapper-class="['formulate-input-wrapper--container']"
              :label-class="['formulate-input-label--contained']"
              :element-class="['formulate-input-element--contained']"
            />

            <FormulateInput
              v-model="user_password"
              type="password"
              name="password"
              label="Password"
              validation="required|matches:/[!@$%^&*#?\-_{}[\]()+=~.]/|min:8"
              :validation-messages="{
                matches:
                  'Passwords must include at least one number and one special character.',
              }"
              :wrapper-class="['formulate-input-wrapper--container']"
              :label-class="['formulate-input-label--contained']"
              :element-class="['formulate-input-element--contained']"
            />

            <FormulateInput
              v-model="user_password_confirmation"
              type="password"
              name="password_confirm"
              label="Confirm Password"
              validation="required|matches:/[!@$%^&*#?\-_{}[\]()+=~.]/|min:8|confirm"
              :validation-messages="{
                matches:
                  'Passwords must include at least one number and one special character.',
              }"
              validation-name="Password confirmation"
              :wrapper-class="['formulate-input-wrapper--container']"
              :label-class="['formulate-input-label--contained']"
              :element-class="['formulate-input-element--contained']"
            />

            <FormulateInput
              v-model="user_store_my_data"
              type="checkbox"
              label="I am good with you storing my data"
              :wrapper-class="['formulate-input-wrapper--checkbox']"
              :label-class="['formulate-input-label--checkbox']"
            />

            <FormulateInput
              v-model="user_marketing"
              type="checkbox"
              label="I’d like to opt in to your marketing material"
              :wrapper-class="['formulate-input-wrapper--checkbox']"
              :label-class="['formulate-input-label--checkbox']"
            />

            <FormulateInput
              v-model="acceptTerms"
              type="checkbox"
              label="I agree to the Terms and Conditions"
              validation="required"
              :wrapper-class="['formulate-input-wrapper--checkbox']"
              :label-class="['formulate-input-label--checkbox']"
            />

            <div class="formulate-form__form-footer">
              <FormulateInput
                type="submit"
                name="Continue"
                :input-class="'btn formulate-form__submit'"
              />

              <p class="formulate-form__footer-copy">
                Already have an account?
                <router-link to="/join" class="formulate-form__link"
                  >Sign in now</router-link
                >
              </p>
            </div>
          </FormulateForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateYourAccount",
  components: {},
  data() {
    return {
      user_name: null,
      user_email: null,
      user_password: null,
      user_password_confirmation: null,
      user_store_my_data: false,
      user_marketing: false,
      acceptTerms: false,
    };
  },
  methods: {
    async createAccount() {
      try {
        if (!this.acceptTerms) {
          return;
        }

        await this.$store.dispatch("UserManagement/registerUser", {
          email: this.user_email,
          password: this.user_password,
          password_confirmation: this.user_password_confirmation,
          first_name: this.user_name,
          store_my_data: this.user_store_my_data,
          user_marketing: this.user_marketing,
        });

        // Log the user in
        await this.$store.dispatch("UserManagement/loginUser", {
          email: this.user_email,
          password: this.user_password,
        });

        this.$router.push({ path: "/account-success" });
      } catch (error) {
        console.error("Registration or login failed:", error);
      }
    },
  },
};
</script>
